import { JobBudget } from './job.budget';

export interface RevenueAndProfitability {

    type: FinanceCodeType | 'Total',
    cost?: number;
    revenue?: number;
    profit?: number;
    margin?: number;

}

export enum FinanceNumberType {
    Negative = 'Negative',
    Positive = 'Positive',
}

export enum FinanceCodeType {
    Service = 'Service',
    Labour = 'Labour',
    Material = 'Material'
}

export const FinancialRecapColor: { [key: string]: string } = {
    [FinanceCodeType.Labour]: '#5EC641',
    [FinanceCodeType.Material]: '#4F92E1',
    [FinanceCodeType.Service]: '#006EA6',

    [FinanceNumberType.Negative]: '#EC3324',
    [FinanceNumberType.Positive]: '#4F92E1',
}

export interface JobFinancialRecapResponse {


    // TODO: can split into 1 props, to make many lightweight API, so UI wont block if the calculation is slow
    totalInvoiced?: number;
    totalPaid?: number;
    totalOutstanding?: number;
    totalOverdue?: number;

    totalProfit?: number;
    totalMargin?: number;
    totalRevenue?: number;
    totalCost?: number;

    budget?: JobBudget;
    cost?: JobBudget;
    revenue?: JobBudget;

    gridData?: RevenueAndProfitability[]


}